import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from 'ng-nice-select';
import { FilePondModule, registerPlugin } from 'ngx-filepond';

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { TaxesRoutingModule } from '@teem/taxes-module/taxes-routing.module';

import { TaxesComponent } from '@teem/taxes-module/taxes.component';
import { AddExpenseComponent } from '@teem/taxes-module/modals/add-expense/add-expense.component';
import { InputTaxTableComponent } from '@teem/taxes-module/components/input-tax-table/input-tax-table.component';

// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';

registerPlugin( 
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);


@NgModule({
  declarations: [
    TaxesComponent,
    AddExpenseComponent,
    InputTaxTableComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    NgxPaginationModule,
    TaxesRoutingModule,
    FilePondModule, 
  ]
})
export class TaxesModule { }
